import React from 'react';
import { useStyles } from './TTIUpgradeModal.styles';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BaseModalLayout from './BaseModalLayout';

export default function TTIUpgradeModal(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <BaseModalLayout {...props}>
      <div className={classes.messageContainer}>
        <span className={classes.message}>
          {props.messages.map(message => (
            <span key={message}>{message}</span>
          ))}
        </span>
      </div>
      <div className={classes.button} onClick={() => navigate('/subscription')}>
        {t('ttiTrainingTab.modal.upgradeButton')}
      </div>
    </BaseModalLayout>
  );
}
